import React from "react"
import ReactDOM from "react-dom/client"
import * as Sentry from "@sentry/react"
import SchedulerApp from "./App"

if (import.meta.env.VITE_SENTRY_DSN) {
    Sentry.init({
        dsn: import.meta.env.VITE_SENTRY_DSN,
        // Setting this option to true will send default PII data to Sentry.
        // For example, automatic IP address collection on events
        sendDefaultPii: true
    })
}

const container = document.getElementById("root")
const root = ReactDOM.createRoot(container)

root.render(<SchedulerApp />)
